import actions from '@/core/store/adesao-publica/actions'
import state from '@/core/store/adesao-publica/state'
import mutations from '@/core/store/adesao-publica/mutations'

export default {
	actions,
	state,
	mutations,
}
